
import CommandLineForm from './CommandLineForm';
import ModifyResourceForm from './ModifyResourceForm';
import CreateVPS from './CreateVPS';
import UnifiedBackupForm from './UnifiedBackupForm';
import DomainForm from './DomainForm';
import ReportsForm from './ReportsForm';
import UpdatesWordPressForm from './UpdatesWordPressForm';

// Configuração dos formulários disponíveis
export const formConfigs = {
  'command_line_form': {
    component: CommandLineForm,
    title: 'Linha de Comando',
    subtitle: 'Digite a linha de comando para continuar'
  },
  'backup': {
    component: UnifiedBackupForm,
    title: 'Backups',
    subtitle: 'Selecione o tipo de backup para continuar'
  },
  'modify_resource': {
    component: ModifyResourceForm,
    title: 'Modificar Recurso',
    subtitle: 'Selecione o recurso para continuar'
  },
  'create_vps': {
    component: CreateVPS,
    title: 'Criar Servidor',
    subtitle: 'Selecione as opções de configuração para continuar'
  },
  'domain_register': {
    component: DomainForm,
    title: 'Registro de Domínios',
    subtitle: 'Registrar novo domínio ou atualizar existente'
  },
  'reports': {
    component: ReportsForm,
    title: 'Relatórios',
    subtitle: 'Gerar relatórios detalhados do sistema'
  },
  'updates_wordpress': {
    component: UpdatesWordPressForm,
    title: 'Atualizações WordPress',
    subtitle: 'Atualizar WordPress em diferentes planos'
  }
};

// Função para obter o formulário baseado no ID
export const getFormById = (formId) => {
  return formConfigs[formId] || null;
};

// Função para listar todos os formulários disponíveis
export const getAllForms = () => {
  return Object.keys(formConfigs);
};

export default formConfigs; 